var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',_vm._b({},'b-form-group',Object.assign({}, _vm.computedGroupBindings, {id: _vm.id}),false),[_c('WidgetGroup',{attrs:{"widgets":_vm.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }